module.exports = __webpack_public_path__ + "img/personal-services-icon.8965dc7e.svg";